export default __webpack_public_path__ + "static/hotel-bg-ccd876941c6f58fb8468b984faa883c6.svg";